import { IArithmeticalEvaluation } from '../../interfaces/Rights';
import StackedBarChartStates from '../Charts/StackedBarChartStates';

interface IIndicators {
    data: IArithmeticalEvaluation[],
    showIndicators: boolean,
    label: string,
    backgroundColor: string,
    classNameLabel?: string,
}

const ArithmeticalEvaluation = ({
    data,
    label,
    showIndicators,
    backgroundColor,
    classNameLabel = 'text-llarge text-primary-10 text-center'
}: IIndicators) => {

    return (
        <div className='rounded-md w-full h-full' style={{ backgroundColor: backgroundColor }}>
            <div className='p-4 w-full md:pb-0'>
                {label.length ? <h6 className={`${classNameLabel}`}>{label}</h6> : <></>}
                <StackedBarChartStates data={data} showIndicators={showIndicators} />
            </div>
        </div>
    )
}

export default ArithmeticalEvaluation